
class DeepLinks {
  constructor(element) {
    this.element = element
    this.list = this.element.querySelector('ul') || this.element.querySelector('ol')
    this.pageContext = this.element.dataset.deepLinksPage === 'true'
    this.init()
  }

  init() {
    this.headings = this.pageContext ? Array.from(document.querySelectorAll('.deep-link')) : Array.from(document.querySelectorAll('h3'))

    document.documentElement.style.scrollBehavior = 'smooth'

    this.headings.forEach((heading) => {
      const innerText = heading.textContent !== '' ? heading.textContent : heading.lastChild.innerHTML

      if(innerText && innerText !== '') {
        const parentElId = heading.closest('div').id
        const listItem = document.createElement('li')
        const anchor = document.createElement('a')

        anchor.innerText = innerText
        anchor.href = `#${parentElId}`

        listItem.appendChild(anchor)
        this.list.appendChild(listItem)
      }

    })
  }
}

// IIFE to invoke component on mount
(function init() {
  const deepLinksEls = document.querySelectorAll('[data-deep-links]')

  deepLinksEls.forEach((el, i, arr) => {
    if (el.getAttribute('bound') !== null) return

    const deepLinks = new DeepLinks(el)

    el.setAttribute('bound', '')

    const id = arr.length > 1 ? `BlockDeepLinks_${i}` : 'DeepLinks'

    self.Decimal.components[id] = { ...deepLinks, async: true }
  })
})()
